import ApiService from '@/core/services/api.service';
import { cmdUrl } from '@/utils/apiUrl';

export default {
  /**
   * Get all providers
   * @returns {Promise<Array>} Array of provider objects
   */
  async getAll() {
    try {
      const response = await ApiService.get('v1/providers/all');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching providers:', error);
      throw error;
    }
  },

  /**
   * Get provider by ID
   * @param {number} id - Provider ID
   * @returns {Promise<Object>} Provider object
   */
  async getById(id, params = {}) {
    try {
      const response = await ApiService.query(
        `${cmdUrl.ProviderUrl.root}/${id}`,
        {
          params,
        },
      );
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching provider with ID ${id}:`, error);
      throw error;
    }
  },

  /**
   * Get providers with pagination and filtering
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number
   * @param {number} params.pageSize - Items per page
   * @param {string} params.name - Name filter
   * @returns {Promise<Object>} Paginated provider data
   */
  async get(params = {}) {
    try {
      const { page = 1, pageSize = 10, name = '' } = params;
      const response = await ApiService.query(cmdUrl.ProviderUrl.root, {
        params: { page, pageSize, name },
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching providers with pagination:', error);
      throw error;
    }
  },

  /**
   * Create a new provider
   * @param {Object} payload - Provider data
   * @returns {Promise<Object>} Created provider response
   */
  async create(payload) {
    try {
      const response = await ApiService.post(cmdUrl.ProviderUrl.root, payload);
      return response.data;
    } catch (error) {
      console.error('Error creating provider:', error);
      throw error;
    }
  },

  /**
   * Update an existing provider
   * @param {number} id - Provider ID
   * @param {Object} data - Updated provider data
   * @returns {Promise<Object>} Updated provider response
   */
  async update(id, data) {
    try {
      const response = await ApiService.put(
        `${cmdUrl.ProviderUrl.root}/${id}`,
        data,
      );
      return response.data;
    } catch (error) {
      console.error(`Error updating provider with ID ${id}:`, error);
      throw error;
    }
  },

  /**
   * Delete a provider
   * @param {number} id - Provider ID
   * @returns {Promise<Object>} Delete response
   */
  async delete(id) {
    try {
      const response = await ApiService.delete(
        `${cmdUrl.ProviderUrl.root}/${id}`,
      );
      return response.data;
    } catch (error) {
      console.error(`Error deleting provider with ID ${id}:`, error);
      throw error;
    }
  },
};
